import React from "react";
import { DoorOpen, Music, BatteryCharging } from "lucide-react";
import { EXPERIENCE } from "../mock";
import Reveal from "./Reveal";

const ICONS = {
  door: DoorOpen,
  music: Music,
  battery: BatteryCharging,
};

const Experience = () => {
  return (
    <section className="bg-[#F5F2ED]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <Reveal className="max-w-2xl mb-14">
          <h2 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl leading-[1.05] text-[#0B1533]">
            {EXPERIENCE.title}
          </h2>
          <p className="font-body text-[#5A607A] mt-5 text-lg">{EXPERIENCE.subtitle}</p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6">
          {EXPERIENCE.items.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal
                key={item.title}
                delay={i * 100}
                className="bg-white rounded-3xl overflow-hidden elev-soft"
              >
                <div className="h-52 overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-7">
                  <div className="w-11 h-11 rounded-full bg-[#EEF1FF] flex items-center justify-center mb-4">
                    {Icon && <Icon size={20} className="text-[#2B4BFF]" />}
                  </div>
                  <h3 className="font-heading font-semibold text-xl tracking-tight text-[#0B1533]">
                    {item.title}
                  </h3>
                  <p className="font-body text-[#5A607A] mt-2 leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Experience;
